const getIconClass = (collection) => {
  switch (collection) {
    case 'users':
      return 'ri-user-fill'
    case 'devices':
    case 'deviceTypes':
      return 'ri-device-fill'
    case 'doctors':
      return 'ri-user-fill'
    case 'orders':
      return 'ri-shopping-cart-fill'
    case 'admin':
      return 'ri-admin-fill'
    case 'data_by_sensor':
      return 'ri-pie-chart-fill'
    case 'web3Wallets':
      return 'ri-wallet-fill'
    case 'sessions':
      return 'ri-calendar-fill'
    default:
      return 'ri-user-fill'
  }
}

export default getIconClass
